import React, { useState } from "react";
import Swal from "sweetalert2";
import "./formFour.css";
import { useNavigate } from "react-router-dom";

const FormFour = (props) => {
  const navigate = useNavigate();

  const [userFour] = useState(props.userFour);
  const [userinfo, setUserInfo] = useState({
    Nombre_Apellido: "",
    Telefono: "",
    Parentesco: "",
  });
  const [errorform, setErrorForm] = useState(false);

  const isValidName = (name) => {
    // Expresión regular para detectar letras repetidas al menos 3 veces consecutivas
    const regex = /(.)\1{2,}/;

    // Verificar si el nombre contiene letras repetidas consecutivas
    if (regex.test(name)) {
      return false; // El nombre no es válido si contiene letras repetidas consecutivas
    }

    return true; // El nombre es válido si no contiene letras repetidas consecutivas
  };

  const ClickPageFive = () => {
    const userPass5 = {
      UserRegistration: {
        newID: userFour.UserRegistration.newID,
        id: userFour.UserRegistration.id,
        credito: { ...userFour.UserRegistration.credito },
        infoUser: { ...userFour.UserRegistration.infoUser },
        infoExtra: { ...userinfo },
      },
    };

    let formIsValid = true;

    const userInfo = userinfo; // Simplifica el acceso a userinfo

    if (
      userInfo.Nombre_Apellido.length < 4 ||
      userInfo.Telefono.length < 6 || // Corregido: Verifica si el teléfono tiene menos de 6 dígitos
      userInfo.Parentesco === "" || // Verifica si no se ha seleccionado una opción en Parentesco
      !isValidName(userInfo.Nombre_Apellido)
    ) {
      formIsValid = false;
    }

    setErrorForm(!formIsValid);

    if (formIsValid) {
      navigate("/Subida_de_fotos", { state: userPass5 });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Por favor verifique todos los campos",
      });
    }
  };

  return (
    <div className="cardForm">
      <div>
        <div className="boxinputanderror">
          <div className="boxInput">
            <i className="fa-solid fa-user icon"></i>
            <input
              className="inputForm"
              placeholder="Nombre y Apellido"
              value={userinfo.Nombre_Apellido}
              onChange={(e) => {
                setUserInfo({ ...userinfo, Nombre_Apellido: e.target.value });
              }}
            />
          </div>
          {errorform && userinfo.Nombre_Apellido?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
        <div className="boxinputanderror">
          <div className="boxInput">
            <i className="fa-solid fa-phone icon"></i>
            <input
              className="inputForm"
              type="number"
              placeholder="Telefono"
              value={userinfo.Telefono}
              onChange={(e) => {
                setUserInfo({ ...userinfo, Telefono: e.target.value });
              }}
            />
          </div>
          {errorform && userinfo.Telefono?.length < 6 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
        <div className="boxinputanderror">
          <div className="boxInput">
            <i className="fa-solid fa-users icon"></i>
            <select
              className="inputForm"
              value={userinfo.Parentesco}
              onChange={(e) => {
                setUserInfo({ ...userinfo, Parentesco: e.target.value });
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value="padre">Padre</option>
              <option value="madre">Madre</option>
              <option value="hijo">Hijo</option>
              <option value="hija">Hija</option>
              <option value="abuela">Abuela</option>
              <option value="abuelo">Abuelo</option>
              <option value="amigo">Amigo</option>
              <option value="otro">Otro</option>
            </select>
          </div>
          {errorform && userinfo.Parentesco?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>
      <div className="BoxInfo">
        <span className="P-Info">
          Monto de prestamo:
          <span className="GreenText">
            ${userFour.UserRegistration.credito.Monto_Certificado}
          </span>
        </span>
        <span className="P-Info">
          Cantidad de cuotas:
          <span className="GreenText">
            {userFour.UserRegistration.credito.Cantidad_Cuotas}
          </span>
        </span>
        <span className="P-Info">
          Valor de Cuota:
          <span className="GreenText">
            ${userFour.UserRegistration.credito.Pago_Mensual}
          </span>
        </span>
      </div>
      <div className="boxButton2">
        <button onClick={ClickPageFive} className="Button">
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default FormFour;
